import useGetApi from 'src/api/useGetApi';
import { GetDivisionsWithTagsResponse } from 'src/types/application/Division';

export const useDivisions = (
  enabled?: boolean,
  // When true, the backend restricts divisions to those containing a warehouse
  // the user can access (warehouse ABAC). Used by the replenishment/inventory
  // pickers; all other callers get the full org division list.
  scopeToWarehouseAccess?: boolean,
) => {
  return useGetApi<GetDivisionsWithTagsResponse>({
    endpoint: 'organization/divisions',
    queryParameters: scopeToWarehouseAccess
      ? { scopeToWarehouseAccess: true }
      : undefined,
    options: {
      enabled,
    },
  });
};

export default useDivisions;
